import React, { Component } from 'react';

class InputTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: this.props.tags !== null ? this.props.tags : []
    };
  }

  componentDidUpdate(prevProps) {

    if (prevProps.tags !== this.props.tags) {
      // if (this.props.selectInput) this.setState({ tags: this.props.tags })
      this.setState({ tags: this.props.tags })
    }
  }

  removeTag = (i) => {
    const newTags = [...this.state.tags];
    newTags.splice(i, 1);
    this.setState({ tags: newTags }, () => this.props.atualizaTags(this.state.tags));
  }

  inputKeyDown = (e) => {
    const val = e.target.value;
    if ((e.key === 'Tab' || e.key === 'Enter') && val) {
      e.preventDefault();
      if (this.state.tags.find(tag => tag.toLowerCase() === val.toLowerCase())) {
        return;
      }
      this.setState({ tags: [...this.state.tags, val] }, () => this.props.atualizaTags(this.state.tags));
      this.tagInput.value = null;
    } else if (e.key === 'Backspace' && !val) {
      this.removeTag(this.state.tags.length - 1);
    }
  }

  render() {
    const { tags } = this.state;
    const { permissaoEdicao, analisarPermissao } = this.props;
    return (
      <div className="input-tag">
        <ul className="input-tag__tags">
          {tags.map((tag, i) => (
            <li key={i}>
              {this.props.selectInput ? tag.label : tag}
              <button type="button" disabled={this.props.pedidoFinalizado || (analisarPermissao && !permissaoEdicao)} onClick={() => {
                this.removeTag(i);
              }}>x</button>
            </li>
          ))}
          {this.props.textInput && (
            <li className="input-tag__tags__input"><input type="text" disabled={analisarPermissao && !permissaoEdicao} onKeyDown={this.inputKeyDown} ref={c => { this.tagInput = c; }} /></li>
          )}
        </ul>
      </div>
    );
  }
}

export default InputTag;